export const FETCH_CURRENCY_LIST = "fetchCurrencyList";
